export { default as AccountsPage } from "./AccountsPage";
export { default as AccountsForm } from "./AccountsForm";



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/accounts/index.js